import api from "../../../api/api";

/** PatchingTemplate */
export const listPatchingTemplates = (params) =>
  api.get("/patching/templates", { params });

export const getPatchingTemplateById = (t_id) =>
  api.get(`/patching/templates/${encodeURIComponent(t_id)}`);

export const createPatchingTemplate = (body) =>
  api.post("/patching/templates", body);

export const updatePatchingTemplate = (t_id, body) =>
  api.put(`/patching/templates/${encodeURIComponent(t_id)}`, body);

export const deletePatchingTemplate = (t_id) =>
  api.delete(`/patching/templates/${encodeURIComponent(t_id)}`);

/** PatchingSchedule (+ latest poll for all authenticated users) */
export const getLatestPatchingSchedule = () =>
  api.get("/patching/schedules/latest");

export const listPatchingSchedules = (params) =>
  api.get("/patching/schedules", { params });

export const getPatchingScheduleById = (s_id) =>
  api.get(`/patching/schedules/${encodeURIComponent(s_id)}`);

export const createPatchingSchedule = (body) =>
  api.post("/patching/schedules", body);

export const updatePatchingSchedule = (s_id, body) =>
  api.put(`/patching/schedules/${encodeURIComponent(s_id)}`, body);

export const deletePatchingSchedule = (s_id) =>
  api.delete(`/patching/schedules/${encodeURIComponent(s_id)}`);
